import CostCenter from "../@types/CostCenter";
import { api } from "./api";

export const fetchCostCenters = async (
  client: string
): Promise<CostCenter[]> => {
  const response = await api.get<CostCenter[]>("/costcenter", {
    params: { client },
  });
  return response.data;
};

export const fetchClients = async (): Promise<string[]> => {
  const response = await api.get<string[]>(`/costcenter/clients`);
  return response.data;
};
